import { IconButton } from "@src/appV2/redesign/components/IconButton";

interface WorkplaceReviewAnonymizeIconProps {
  onAnonymize: () => void;
}

export function WorkplaceReviewAnonymizeIcon(props: WorkplaceReviewAnonymizeIconProps) {
  const { onAnonymize } = props;

  return (
    <IconButton
      invert
      size="small"
      iconType="eye"
      variant="contained"
      onClick={(event) => {
        event.stopPropagation();
        onAnonymize();
      }}
    />
  );
}
